export default {
    moves: 'Moves',
    time: 'Time',
    score: 'Score',
    settings: 'Settings',
    sounds: 'Sounds',
    autocomplete: 'Autocomplete',
    leftHanded: 'Left-handed',
    newDeal: 'New Deal',
    design: 'Design',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    expert: 'Expert',
    master: 'Master',
    random: 'Random',
    balanced: 'Balance',
    rulesKlondikeURL: 'https://solitaires.com/articles/how-to-play-solitaire/',
    cardHighlight: 'Card highlighting',
    rulesSpiderURL: 'https://solitaires.com/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Autoplay',
    noMagicNeeded: 'No Magic Wand needed - continue the game yourself!',
    leaveFeedback: 'Leave feedback',
    feedbackThankYou: 'We appreciate your feedback!',
    feedbackError: 'An error occurred. Your message wasn’t sent.',
    thanksSubscribing: 'Thanks for subscribing!',
    rulesPyramidURL: 'https://solitaires.com/articles/how-to-play-pyramid-solitaire/',

    tutorialSkip: 'Skip',
    tutorialRestart: 'Restart',

    klondikeTutorialStep1: 'Your goal is to move all cards to the foundation, building each suit in order from Ace to King — like <span style="color: #F11F1F;">A♥, 2♥, 3♥</span>, and so on. Tap a card to send it there!',
    klondikeTutorialStep2: 'Great! Keep building sequences in the foundation.',
    klondikeTutorialStep3: 'Well done! You can move cards between columns — just place a card on one that’s a rank higher and the opposite color.',
    klondikeTutorialStep4: 'You can move a sequence if its bottom card is one rank lower and a different color than the card you’re placing it on.',
    klondikeTutorialStep5: 'If there’s an empty column on the tableau, you can only place a King or a sequence that starts with a King there.',
    klondikeTutorialStep6: 'If you run out of moves, tap the deck to flip new cards. You can place them on the tableau or into the foundation.',
    klondikeTutorialStep7: 'All right! Now keep playing on your own.',
    klondikeTutorialStep8: 'If the deck runs out, tap it to refresh and keep playing.',
    klondikeTutorialStep9: 'You’re almost there! Complete the foundation stacks to win the game.',

    spiderTutorialStep1: 'Your goal is to move all cards to the foundation by forming descending sequences from King to Ace on the tableau. Tap a card to start building a sequence!',
    spiderTutorialStep2: "You can move a sequence if its bottom card is one rank lower than the one you're placing it on. Tap it to move the whole stack!",
    spiderTutorialStep3: 'Well done! Keep building the sequence — once it’s complete, it will move to the foundation automatically.',
    spiderTutorialStep4: 'If you run out of moves, tap the deck to deal new cards — one to each column.',
    spiderTutorialStep5: 'Nice work! You’ve got this — go ahead and finish the game!',

    freeCellTutorialStep1: 'Your goal is to move all cards to the foundation, building each suit in order from Ace to King — like A♠, 2♠, 3♠, and so on. Tap a card to send it there!',
    freeCellTutorialStep2: 'You can move cards between columns on the tableau — just place a card on one that’s a rank higher and a different color.',
    freeCellTutorialStep3: 'You can move a sequence if its bottom card is one rank lower and a different color than the card you’re placing it on. Remember: you can’t move more cards than the number of empty free cells plus one.',
    freeCellTutorialStep4: 'Great! You can place any single card or a sequence in an empty column on the tableau.',
    freeCellTutorialStep5: 'Free cells are special spots for temporarily storing cards. Each one can hold a single card, which you can move back to the tableau or foundation when needed.',
    freeCellTutorialStep6: 'Now it’s your turn! Use what you’ve learned to finish the game on your own!',

    startTutorialPopupTitle: 'Welcome! Take a quick tutorial and learn the basics before you start playing.',
    skipTutorial: 'Skip',
    startTutorial: 'Start Tutorial',
};
